import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class ClearingHouse {

  public static ALL: string = "";
  public static ALL_TEXT: string = "ALL";
  public static DEFAULT_CLEARING_HOUSE: string = "DEFAULT";

  @JsonProperty()
  clearingHouseCode: string | undefined;
  @JsonProperty()
  description: string | undefined;
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

  @JsonProperty()
  timeZone: string | undefined;

}
